// bus.js
import Vue from 'vue'
// export default new Vue()
var Bus = new Vue({});
export default Bus


// WEBPACK FOOTER //
// ./src/assets/common/bus.js